// extracted by mini-css-extract-plugin
module.exports = {"prev":"pagination_prev__3FWdK","current":"pagination_current__2Q5Kt","next":"pagination_next__1vZt6"};